<template>
  <div>
    <div class="menu">
      <div class="content1">
        <!-- <div class="logo">
          <router-link to="/">千种药用植物基因组数据库</router-link>
        </div> -->
        <div class="btn">
          <!-- <el-menu class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1" class="black"><router-link to="/">Home</router-link></el-menu-item>
            <span></span>
            <el-menu-item index="3"><router-link to="/blastcenter">Blast</router-link></el-menu-item>
             <el-menu-item index="4">|</el-menu-item>
            <el-menu-item index="5"><router-link to="/primer">Primer design</router-link> </el-menu-item>
            <el-menu-item index="3"><router-link to="/download">Download</router-link></el-menu-item>
          </el-menu> -->
          <ul>
            <li class="black"><router-link to="/">Home</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/blastcenter">Blast</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/primer">Primer design</router-link></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="contenter">
      <div class="mtitle">
        <div class="box">
          <div class="font">CONTACT US</div>
          <!--<div class="line">
            <div class="s"></div>
            <div class="z"><i>CONTACT US</i></div>
            <div class="s"></div>
          </div>-->
        </div>
      </div>
      <div class="contact">
        <div class="left">
          <div class="t">Wuhan Benagen Technology Co., Ltd</div>
          <div class="d">
            <div class="q"><i class="el-icon-phone-outline"></i></div>
            <div>Tel：027-62435310</div>
          </div>
          <div class="d">
            <div class="q"><i class="el-icon-message"></i></div>
            <div>Email：service@benagen.com</div>
          </div>
          <div class="d">
            <div class="q"><i class="el-icon-location-outline"></i></div>
            <div>Address: No.888 Gaoxin Avenue, Jiangxia District, Wuhan, Hubei , China</div>
          </div>
          <div class="d">
            <div class="q"><i class="el-icon-postcard"></i></div>
            <div>Postcode：430000</div>
          </div>
          <!--<div class="d">
            <div class="q"><i class="el-icon-s-custom"></i></div>
            <div>贝纳课堂-Nanopore交流QQ群：992789813</div>
          </div>-->
          <div class="d">
            <div class="q"><i class="el-icon-paperclip"></i></div>
            <div>
              Website：<a href="http://www.benagen.com/" target="_blank"
                >http://www.benagen.com/</a
              >
            </div>
          </div>
        </div>
        <div class="right">
          <!-- //114.477493,30.489859 -->

          <div id="containermap"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.$nextTick(function () {
      var map = new BMapGL.Map("containermap");
      var point = new BMapGL.Point(114.555074,30.482598);
      map.centerAndZoom(point, 14);
      var opts = {
        width: 270,
        height: 80,
        title: "Wuhan Benagen Technology Co., Ltd",
      };
      var infoWindow = new BMapGL.InfoWindow(
        "Address：No.888 Gaoxin Avenue, Jiangxia District, Wuhan, Hubei , China",
        opts
      );
      map.openInfoWindow(infoWindow, point);
      function getInfoContent() {
        alert(infoWindow.getContent());
      }
    });
  },
};
</script>
<style scoped>
 #containermap {
        overflow: hidden;
        width: 460px;
        height: 100%;
        margin: 0 0 0 20px;
        font-family: "微软雅黑";
        font-size: 14px;
    }
    .BMap_bubble_title{
        color: seagreen;
    }
 .BMap_cpyCtrl {display: none; }
 .anchorBL {display: none; }

 .contact {
  display: flex;
  width: 800px;
  /* border: 1px solid red; */
  margin: 50px auto;
}
.contact .left {
  /* border: 1px solid red; */
  color: rgb(124, 122, 122);
}
.contact .left .t {
  font-size: 17px;
  /* line-height: 45px; */
  margin: 0 0 15px 0;
  color: rgb(124, 122, 122);
}
.contact .left .d {
  display: flex;
  line-height: 35px;
  font-size: 14px;
}
.contact .left .d a {
  color: rgb(124, 122, 122);
}
.contact .left .d .q {
  width: 25px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  border-radius: 50%;
  margin: 5px 10px 0 0;
  border: 1px solid rgb(124, 122, 122);
}
.contact .right {
  /* border: 1px solid red; */
}
.mtitle {
  /* border: 1px solid red; */
}
.mtitle .box {
  margin: 0 auto;
  width: 400px;
  /* border: 1px solid red; */
  text-align: center;
}
.mtitle .box .font {
  line-height: 50px;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}
.mtitle .box .line {
  display: flex;
}
.mtitle .box .s {
  height: 1px;
  background: #ccc;
  width: 130px;
  margin: 10px 0;
}
.mtitle .box .z {
  flex: 1;
  margin: 0 10px;
  color: #ccc;
  font-size: 12px;
}
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #ccc;
}
.menu .content1 {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  /* border: 1px solid red; */
}
.menu .black {
  color: #000;
}
.menu .content1 .logo {
  float: left;
  width: 250px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 50px;

  text-align: center;
}
.menu .content1 .logo a {
  text-decoration: none;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}
.menu .content1 .btn {
  /* float: right; */
  width: auto;
}
.menu .content1 .btn ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.menu .content1 .btn ul li {
  float: left;
  padding: 0 20px;
  line-height: 50px;
}
.menu .content1 .btn ul li.ww {
  color: #ccc;
}
.menu .content1 .btn ul li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}
.menu .content1 .btn ul li:nth-child(1) a {
  color: #000;
  font-weight: 700;
}
.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}
.contenter {
  width: 1140px;
  margin: 0 auto 30px auto;
  /* height: 500px; */
  box-shadow: 0 0 10px #bbb;
  padding: 20px 30px 30px 30px;
  background: #fff;
  min-height: 500px;
}
.contenter .title {
  height: 70px;
  width: 100%;
  /* border: 1px solid red; */
  line-height: 70px;
  font-size: 16px;
  font-weight: bold;
}
.contenter .title .el-icon-document {
  margin-right: 10px;
  font-size: 20px;
  /* line-height: 30px; */
  color: seagreen;
  font-weight: bold;
}
.contenter .des {
  background: #eef6f0;
  color: #555;
  line-height: 25px;
  padding: 15px 20px;
  font-size: 14px;
  text-indent: 30px;
}
.contenter .img {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  line-height: 25px;
  overflow: auto;
  padding-bottom: 30px;
}
</style>
